import { Container } from './Container';
import {
  BuildingStorefrontIcon,
  GiftIcon,
  MegaphoneIcon,
  QrCodeIcon,
  RocketLaunchIcon,
} from '@heroicons/react/24/outline';

const useCases = [
  {
    icon: BuildingStorefrontIcon,
    title: 'Client campaigns',
    description: 'Duplicate a proven game, swap the brand, and launch a repeatable campaign for another client.',
    outcome: 'Repeatable deliverable',
  },
  {
    icon: QrCodeIcon,
    title: 'QR and live activations',
    description: 'Put the game on stands, posters, counters, packaging, or live screens so people can scan and compete.',
    outcome: 'Scan, play, rank',
  },
  {
    icon: RocketLaunchIcon,
    title: 'Launches and pop-ups',
    description: 'Give people a quick branded challenge around a product launch or physical moment.',
    outcome: 'Play, score, click',
  },
  {
    icon: MegaphoneIcon,
    title: 'Instagram story drops',
    description: 'Share a game link with followers and turn passive views into plays, scores, and clicks.',
    outcome: 'Story link to game',
  },
  {
    icon: GiftIcon,
    title: 'Giveaways and prize draws',
    description: 'Players enter by playing. Pick a winner live from the leaderboard when entries close.',
    outcome: 'Play to enter, pick to win',
  },
];

export function UseCases() {
  return (
    <section id="channels" aria-label="Campaign channels" className="sf-section sf-section-lift py-10 sm:py-14">
      <Container>
        <div className="mx-auto max-w-5xl">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-arcade tracking-tight text-gch-accent sm:text-3xl">
              One game, many campaign channels
            </h2>
            <p className="mt-3 text-base text-gch-text-secondary max-w-2xl mx-auto">
              Share the same branded game across every channel you already use.
            </p>
          </div>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {useCases.map(({ icon: Icon, title, description, outcome }) => (
              <li
                key={title}
                className="rounded-xl bg-white/5 p-5 sm:p-6 flex items-start gap-4"
              >
                <div className="shrink-0 rounded-lg bg-gch-accent/10 ring-1 ring-gch-accent/30 p-2.5">
                  <Icon className="h-5 w-5 text-gch-accent" aria-hidden />
                </div>
                <div className="min-w-0">
                  <h3 className="text-base font-semibold text-white">{title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-gch-text-secondary">{description}</p>
                  <p className="mt-2 text-[11px] font-bold uppercase tracking-wider text-gch-accent">{outcome}</p>
                </div>
              </li>
            ))}
          </ul>

        </div>
      </Container>
    </section>
  );
}
